import { Box } from "@material-ui/core";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { fget } from "../../../API/callsAPI.js";
import Loader from "../../Utilities/Loader/Loader.jsx";
import sequencerMixNewStyles from "../SequencerOverview/SequencerMixNewStyles.js";

const TaskListForSequencerMix = ({
  templateId,
  setSelectedPhase,
  selectedPhase,
}) => {
  const classes = sequencerMixNewStyles();
  const [isLoaded, setIsLoaded] = useState(false);
  const [taskList, setTaskList] = useState([]);

  const getPhases = async () => {
    try {
      const res = await fget({ url: `phase/?template=${templateId}` });
      setTaskList(res?.data?.results);
      setIsLoaded(true);
    } catch (error) {
      console.log(error);
      setIsLoaded(true);
    }
  };
  useEffect(() => {
    if (templateId) {
      getPhases();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId]);

  return (
    <div className={classes.rightContainer}>
      {isLoaded ? (
        <>
          <Box
            style={{
              border:
                selectedPhase === ""
                  ? "1px solid #6C65D9"
                  : "1px solid #3F404A",
            }}
            className={classes.singleTaskTemplate}
            onClick={() => setSelectedPhase("")}
          >
            <Typography className={classes.taskTemplateTitle}>None</Typography>
          </Box>
          {taskList?.map((sin) => (
            <Box
              style={{
                border:
                  selectedPhase === sin.id
                    ? "1px solid #6C65D9"
                    : "1px solid #3F404A",
              }}
              className={classes.singleTaskTemplate}
              onClick={() =>
                setSelectedPhase(selectedPhase !== sin.id ? sin.id : "")
              }
            >
              <Typography className={classes.taskTemplateTitle}>
                {sin?.name}
              </Typography>
              <Typography className={classes.versionCount}>
                26 versions
              </Typography>
            </Box>
          ))}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default TaskListForSequencerMix;
